import { render } from "./DataFactoryConfigurationForm.vue?vue&type=template&id=2e1e001c&ts=true"
import script from "./DataFactoryConfigurationForm.vue?vue&type=script&lang=ts"
export * from "./DataFactoryConfigurationForm.vue?vue&type=script&lang=ts"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__